import {useState} from 'react';

const getRandomCopy = (items: string[]) => items[Math.floor(Math.random() * items.length)];

export const RotatingHeroTitle = ({items}: {items: string[]}) => {
  const [title] = useState(() => getRandomCopy(items));

  return <>{title}</>;
};
